import { useBlocker } from 'react-router-dom';

import { getDemoMode } from '@/hooks/DemoContext';
import { isRouteAllowedInDemo } from '@/utils/functions/isRouteAllowedInDemo/isRouteAllowedInDemo';

import type { BlockerFunction } from 'react-router-dom';

const useDemoBlocker = () => {
  const shouldBlock: BlockerFunction = ({ nextLocation }) =>
    getDemoMode() && !isRouteAllowedInDemo(nextLocation.pathname);

  const blocker = useBlocker(shouldBlock);

  const resetBlock = () => {
    if (blocker.state === 'blocked') blocker.reset();
  };

  return {
    isBlocked: blocker.state === 'blocked',
    resetBlock,
  };
};

export { useDemoBlocker };
